import { useParams } from 'react-router-dom';
import { useDecision } from '@optimizely/react-sdk';
import { PathParams } from './useNewFeedVisibility.types';

const useNewFeedVisibility = (idCommunity?: string) => {
  const { idCommunity: idCommunityPathParam } = useParams() as PathParams;
  const [decision] = useDecision('com_eng_web_disable_new_feed');

  const targetCommunity = idCommunity || idCommunityPathParam;
  const communities = decision.variables?.communities as { ids: string[] };
  const enableNewFeed =
    decision.enabled &&
    decision.variationKey === 'new_feed' &&
    !communities?.ids.includes(targetCommunity);

  return {
    enableNewFeed
  };
};

export default useNewFeedVisibility;
